export default {
  initialized: false,
  updated: false,
  registration: null,
  lang: localStorage.getItem('lang') || 'en',
};
